import { useEffect, useLayoutEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../app/hooks';
import { FilterValuesObj } from '../features/filter/interfaces';
import { fetchFilters, getFiltersValueFromURL } from '../features/filter/slice';
import { filterKeys, FilterValueKey } from '../features/filter/utils';
import { fetchTranslations } from '../features/translation/slice';

const prepareValuesFromURL = ({ params, keys }: { params: URLSearchParams; keys: string[] }): FilterValuesObj[] => {
  const filtersValueByUrl: FilterValuesObj[] = keys.map((key) => {
    if (key === FilterValueKey.OUTPUT_PRESSURE || key === FilterValueKey.SUPPLY_PRESSURE) {
      const MAX_VALUE_ALLOWED = 10;

      return {
        [key]: Number(params.get(key)) > MAX_VALUE_ALLOWED ? MAX_VALUE_ALLOWED : Number(params.get(key)),
      };
    }
    return {
      [key]: Number(params.get(key)) ? Number(params.get(key)) : params.get(key) ?? '',
    };
  });

  return filtersValueByUrl;
};

export default function useInit(): void {
  const [searchParams] = useSearchParams();
  const { search } = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchFilters());
    dispatch(fetchTranslations());
  }, [dispatch]);

  useLayoutEffect(() => {
    if (search.length > 0) {
      const filterValuesFromUrl = prepareValuesFromURL({
        keys: filterKeys,
        params: searchParams,
      });

      dispatch(getFiltersValueFromURL(filterValuesFromUrl));
    }
  }, [dispatch, search, searchParams]);
}
